<template>
  <div
    class="io-filter-cont"
    :style="`flex-direction: ${!$vuetify.breakpoint.mobile ? 'row' : 'column'}`"
  >
    <!-- TOP BAR -->
    <div style="position: relative;" v-if="presentation && $vuetify.breakpoint.mobile">
      <v-btn
        class="fullscreen-back"
        small
        tonal
        @click="closeFilter()"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>
    <!-- PLAYER AND BAR -->
    <v-sheet
      class="io-left"
      :style="flexIfPresentation"
    >
      <v-sheet
        class="d-flex align-center px-2"
        style="height: 56px; position: relative"
        :class="$vuetify.breakpoint.mobile ? 'mobile-bar-hide' : ''"
      >
        <v-btn
          v-if="presentation"
          style="margin-top: -20px; position: absolute; top: 30px; right: 10px"
          text
          class="ml-2"
          :x-small="$vuetify.breakpoint.mobile"
          :small="!$vuetify.breakpoint.mobile"
          @click="closeFilter()"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>

        <v-btn v-else
          text
          small
          @click="backButton"
          >
          <!-- @click="$router.go(-1)" -->
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>

        <v-icon
          style="color: black;"
          class="ml-3"
        >
          mdi-filter-outline
        </v-icon>
        <h3
          class="ml-2 mb-0"
          style="overflow: hidden; display: inline-block;"
        >
          {{ filter && filter.title ? filter.title : 'Nimetön' }}
        </h3>
        <v-btn-toggle
          v-if="openedEventFeedOptions.length > 1"
          :value="selected_feed"
          mandatory
          dense
          class="ml-auto"
          @change="changeFeed"
        >
          <v-btn
            v-for="feed in openedEventFeedOptions"
            :key="feed.value"
            small
            :value="feed.value"
          >
            {{ feed.text }}
          </v-btn>
        </v-btn-toggle>
      </v-sheet>
      <v-responsive
        class="io-left-player"
        :aspect-ratio="$vuetify.breakpoint.mobile ? '16/9' : null"
        :class="playerIfPresentation"
        style="display: flex; flex-direction: row; align-items: center;"
        :style="`
          background-color: ${ !$vuetify.theme.dark ? '#000000' : '#ffffff'},
          max-width: ${ !$vuetify.breakpoint.mobile ? 'calc(100vw - 356px)' : '' }
        `"
      >
        <template v-if="!loading_some && all_events && all_events.length">
          <editorPlayer
            :height="playerHeight"
            style="margin: auto;"
            :options="options"
            :key="player_key"
            :filter="true"
            @next="nextEvent()"
            @last="lastEvent()"
          ></editorPlayer>

          <event-data
            :event="openedEvent"
          ></event-data>
          <quality-panel-filter />
        </template>

        <div
          v-else
          style="height: 100%; width: 100%; background-color: black; display: flex; justify-content: center; align-items: center;"
        >
          <div v-if="error || (!loading_some && (!all_events.length || !games.length))" style="color: white; font-size: 3em; text-align: center;">
            {{ error ? error : "Ei tuloksia"}}
            <div>
              <v-btn v-if="!presentation" @click="backButton">
                <v-icon>mdi-arrow-left</v-icon>
                {{$t('back')}}
              </v-btn>
              <v-btn v-else @click="closeFilter()">
                <v-icon>mdi-close</v-icon>
                {{$t('back')}}
              </v-btn>
            </div>
          </div>
          <div v-else-if="loading_some">
            <v-progress-circular indeterminate color="white"></v-progress-circular>
          </div>
        </div>

      </v-responsive>
      <v-sheet style="padding-inline: 5px" :class="$vuetify.breakpoint.mobile ? 'mobile-bar-hide' : ''">
        <clip-bar
          v-if="options"
          :buffer="options.buffer"
          :end_buffer="options.end_buffer"
          :starttime="options.starttime"
          :endtime="options.endtime"
        ></clip-bar>
        <bar
          v-if="!$vuetify.breakpoint.mobile"
          :filter="filter"
          @apply="openEvent(openedEvent)"
          :compact="true"
        >
        </bar>
      </v-sheet>
    </v-sheet>

    <!-- Item list -->
    <div
      :class="presentation ? 'io-right-prese' : 'io-right'"
      :style="`width: ${$vuetify.breakpoint.mobile ? '100%' : '300px !important'}; height: ${barHeight}px;`"
    >
      <filter-bar
        :h="barHeight"
        @openEvent="openEvent($event)"
        :events="events"
        :playingEvent="openedEvent"
      ></filter-bar>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import FilterBar from '../components/filters/FilterBar.vue'
import editorPlayer from '../components/video/ClipEditor/EditorPlayer.vue'
import Bar from '../components/video/player/Bar.vue'
import ClipBar from '../components/video/player/ClipBar.vue'
import EventData from '../components/video/player/EventData.vue'
import QualityPanelFilter from '@/components/quality/QualityPanelFilter.vue'
import { updateTitleFromComponent } from '@/utils/titleHelper'

export default {
  props: ['presentation'],
  components: { editorPlayer, Bar, ClipBar, FilterBar, EventData,
    QualityPanelFilter
  },
  shortcuts: {
    up: function() {
      if (this.allFilteredEvents.length > 0) {
        this.lastEvent()
      }
    },
    down: function() {
      if (this.allFilteredEvents.length > 0) {
        this.nextEvent()
      }
    }
  },
  data: () => ({
    noevents: false,
    error: null,
    windowSize: {
      width: window.innerWidth,
      height: window.innerHeight
    }
  }),
  created() {
    this.SET_SOURCE_TIME_OFFSET(0)
    if(this.$route.query.quality_control === 'true') {
      this.SET_IS_QUALITY_CONTROL(true)
      this.SET_QUALITY_CONTROL_VIEW(this.$route.query.qc_view)
      this.SET_QUALITY_CONTROL_EVENT_KEY(this.$route.query.event_key)
      this.SET_QUALITY_CONTROL_PERCENTAGE_CHECKED(this.$route.query.percentage_checked)
      this.SET_QUALITY_CONTROL_ANALYSIS_PHASE(this.$route.query.analysis_phase)
    }
    this.startGettingStuff()
  },
  mounted() {
    window.addEventListener('resize', this.handleResize)
    this.UPDATE_SCALE()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  computed: {
    ...mapGetters('filter', [
      'loading',
      'events',
      'eventsFlat',
      'buffer',
      'end_buffer',
      'filter',
      'eventById',
      'all_events',
      'allFilteredEvents',
      'options',
      'player_key',
      'games',
      'loading_some',
      'openedEvent',
      'selected_feed',
      'openedEventFeedOptions'
    ]),
    ...mapGetters('player', [
      'player'
    ]),
    flexIfPresentation() {
      return this.$vuetify.breakpoint.mobile ? 'flex-grow: 0 !important' : 'flex-grow: 1 !important'
    },
    playerIfPresentation() {
      return this.$vuetify.breakpoint.mobile ? 'mobile-video': 'desktop-video'
    },
    playerHeight() {
      if (this.presentation) return this.$vuetify.breakpoint.mobile ? 'height: 100%' : 'height: calc(90vh - 165px)'
      return this.$vuetify.breakpoint.mobile ? 'height: 100%' : 'height: calc(100vh - 165px)'
    },
    barHeight() {
      if (!this.$vuetify.breakpoint.mobile) {
        return this.windowSize.height;
      } else {
        const pageHeight = this.windowSize.height;
        const pageWidth = this.windowSize.width;
        const playerHeight = pageWidth / (16 / 9); // 16:9 aspect ratio
        const topBarHeight = 55;
        const restHeight = pageHeight - playerHeight - topBarHeight;
        return restHeight > 0 ? restHeight : 0;
      }
    }
  },
  methods: {
    ...mapActions('filter', [
      'getFilterData',
      'getFilterDataNoSave',
      'getFilterGames',
      'openEvent',
      'nextEvent',
      'lastEvent'
    ]),
    ...mapActions('presentation', [
      'closeFilter',
    ]),
    ...mapMutations('filter', [
      'SET_PLAYING_EVENT',
      'SET_IS_QUALITY_CONTROL',
      'SET_QUALITY_CONTROL_VIEW',
      'SET_QUALITY_CONTROL_EVENT_KEY',
      'SET_QUALITY_CONTROL_PERCENTAGE_CHECKED',
      'SET_QUALITY_CONTROL_ANALYSIS_PHASE'
    ]),
    ...mapMutations('draw', [
    'UPDATE_SCALE'
    ]),
    ...mapMutations('player', [
      'SET_SOURCE_TIME_OFFSET'
    ]),
    backButton() {
      if(this.$route.query.from) {
        this.$router.push(this.$route.query.from)
        return
      }
      if(this.$route.path.includes('library')){
        this.$router.replace('/library')
        return
      }
      if(this.$route.path.includes('presentation')) {
        this.switchItem('filter')
      }
      this.$router.replace('/filters')
    },
    openFirstEvent() {
      if(!this.allFilteredEvents.length) {
        this.noevents = true
        return
      }

      this.openEvent(this.allFilteredEvents[0])
    },
    changeFeed(feed) {
      if(!this.openedEvent) return
      this.openEvent({ event: this.openedEvent, feed })
    },
    seekFilterStartAfterMount() {
      if(!this.options?.starttime) return

      this.$nextTick(() => {
        setTimeout(() => {
          this.player?.seek?.(this.options.starttime)
        }, 300)
        setTimeout(() => {
          this.player?.seek?.(this.options.starttime)
        }, 900)
      })
    },
    // openEvent(event) {
    //   this.options = {
    //     starttime: event.starttime - this.buffer,
    //     endtime: event.is_point ? event.starttime + this.end_buffer : event.endtime + this.end_buffer,
    //     source: event.video.mp4_url || event.video.video_url || event.video.original_url,
    //     mimeType: event.video.video_type == 'hls' ? 'application/x-mpegURL' : 'video/mp4',
    //     buffer: 0
    //   }

    //   this.SET_PLAYING_EVENT(event)

    //   this.$nextTick(() => {
    //     this.gameKey++
    //   })
    //   if(this.presentation) return;
    //   this.$router.replace({ query: { ...this.$route.query, event_id: event.id }})
    // },
    startGettingStuff() {
      let id;
      const query_filter = this.$route.query.filter
      if(this.presentation) id = this.$route.query.event_id;
      else id = this.$route.params.id;

      this.getFilterGames({
        id,
        filter: query_filter,
        offset: 0,
        limit: 5
      })
      .then(() => {
        this.$nextTick(() => {
          if(this.filter && this.filter.title) {
            updateTitleFromComponent(this.filter.title)
          } else {
            updateTitleFromComponent('Suodatus')
          }
        })
      })
      .catch(() => {
        this.error = "Jotain meni pieleen"
      })
    },
    handleResize() {
      this.windowSize = {
        width: window.innerWidth,
        height: window.innerHeight
      };
    }
  },
  watch: {
    player_key() {
      this.seekFilterStartAfterMount()
    }
  }
}
</script>

<style lang="scss" scoped>
  .io-filter-cont {
    height: 100%;
    width: 100%;
    display: flex;
  }

  .io-left {
    display: flex;
    background-color: black;
    flex-direction: column;

    &-player {
      flex-grow: 1;
      display: flex;
    }
  }

  .io-right-prese {
    width: 300px;
  }

  .desktop-video {
    height: calc(90vh - 165px);
  }

  .fullscreen-back {
    display: none;
  }

  @media (orientation: landscape) {
    .mobile-video {
      height: 90vh;
    }
    .mobile-bar-hide {
      display: none;
    }
    .fullscreen-back {
      display: inline;
      position: absolute;
      top: 2vh;
      right: 2vh;
      z-index: 1;
    }
  }

  @media (orientation: portrait) {
  }
</style>